module.exports = __webpack_public_path__ + "static/media/btctzLogo.96781eab.png";